function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import { useBrand } from "../BrandProvider";
import SvgIcon from "../SvgIcon";
import { BOS, HALIFAX, LLOYDS, LLOYDS2023, MBNA, SCOTTISH_WIDOWS, WHITE_LABEL_DARK, WHITE_LABEL_LIGHT } from "../../constants";
var BosIcon = function BosIcon(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M8.513 13.312L4.257 8.968 0 13.312 8.604 22 24 6.344 19.743 2z",
    fillRule: "evenodd"
  }));
};
BosIcon.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};
var HalifaxIcon = function HalifaxIcon(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("polygon", {
    fill: "currentColor",
    points: "22.2928932 3.29289322 23.7071068 4.70710678 7 21.4142136 0.292893219 14.7071068 1.70710678 13.2928932 7 18.585"
  })));
};
HalifaxIcon.defaultProps = {
  width: "24px",
  height: "24px",
  viewBox: "0 0 24 24",
  version: "1.1",
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink"
};
var Lloyds2023Icon = function Lloyds2023Icon(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M19.743 2L8.513 13.227 4.257 8.916 0 13.227l8.605 8.623L24 6.312z",
    fillRule: "evenodd"
  }));
};
Lloyds2023Icon.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};
var LloydsIcon = function LloydsIcon(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M7.60544 22L0.390108 14.4984C-0.130036 13.9576 -0.130036 13.0841 0.390108 12.5433C0.910253 12.0026 1.75048 12.0026 2.27063 12.5433L7.60544 18.0898L21.7294 3.40558C22.2495 2.86481 23.0897 2.86481 23.6099 3.40558C24.13 3.94636 24.13 4.81997 23.6099 5.36074L7.60544 22Z",
    fill: "currentColor"
  }));
};
LloydsIcon.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var MaterialIcon = function MaterialIcon(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M7.77843 20.1066L0 12.3284L1.41447 10.9142L7.77843 17.2782L22.0566 3L23.4708 4.4143L7.77843 20.1066Z",
    fill: "currentColor"
  }));
};
MaterialIcon.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var MbnaIcon = function MbnaIcon(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M22.5077761,6.85528723 C23.2296464,6.13335551 23.1575884,4.91856657 22.2911721,4.29516945 C21.6129175,3.80612091 20.6589626,3.94986838 20.0673251,4.54132162 L10.0202987,14.5874879 C9.65355839,14.9551497 9.05725213,14.9551497 8.68977464,14.5874879 L4.93280564,10.8311332 C4.3403695,10.2394957 3.38715181,10.0945811 2.70816004,10.5840596 C1.84248086,11.207211 1.77042284,12.4231671 2.49229312,13.1449146 L8.68492162,19.3384645 C9.05479491,19.706372 9.65282122,19.706372 10.0210973,19.3384645 L22.5077761,6.85528723 Z"
  }));
};
MbnaIcon.defaultProps = {
  fill: "currentColor",
  fillRule: "evenodd",
  width: "24px",
  height: "24px",
  viewBox: "0 0 24 24",
  version: "1.1",
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink"
};
var ScottishWidowsIcon = function ScottishWidowsIcon(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, ".prefix__st0", "{", "fill-rule:evenodd;clip-rule:evenodd;fill:currentColor", "}"), /*#__PURE__*/React.createElement("path", {
    className: "prefix__st0",
    d: "M0.4,11.9c0.5-0.5,1.3-0.5,1.8,0l5.5,5.5l14.1-14c0.5-0.5,1.3-0.5,1.8,0c0.5,0.5,0.5,1.3,0,1.8L7.7,20.9 l-7.3-7.2C-0.1,13.1-0.1,12.3,0.4,11.9z"
  }));
};
ScottishWidowsIcon.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
import React from 'react';
import { ThemeContext } from 'styled-components';
export default function (_ref) {
  var _theme$assets, _theme$assets$icons;
  var rest = _extends({}, _ref);
  var _ref2 = useBrand() || {},
    _ref2$brand = _ref2.brand,
    brand = _ref2$brand === void 0 ? LLOYDS : _ref2$brand;
  var theme = React.useContext(ThemeContext) || {};
  var svg;
  if ((_theme$assets = theme.assets) !== null && _theme$assets !== void 0 && (_theme$assets$icons = _theme$assets.icons) !== null && _theme$assets$icons !== void 0 && _theme$assets$icons.tick) {
    var _theme$assets2, _theme$assets2$icons;
    svg = (_theme$assets2 = theme.assets) === null || _theme$assets2 === void 0 ? void 0 : (_theme$assets2$icons = _theme$assets2.icons) === null || _theme$assets2$icons === void 0 ? void 0 : _theme$assets2$icons.tick;
  } else {
    switch (brand) {
      case LLOYDS:
        svg = LloydsIcon;
        break;
      case BOS:
        svg = BosIcon;
        break;
      case HALIFAX:
        svg = HalifaxIcon;
        break;
      case LLOYDS2023:
        svg = Lloyds2023Icon;
        break;
      case MBNA:
        svg = MbnaIcon;
        break;
      case SCOTTISH_WIDOWS:
        svg = ScottishWidowsIcon;
        break;
      case WHITE_LABEL_DARK:
      case WHITE_LABEL_LIGHT:
        svg = MaterialIcon;
        break;
      default:
        // eslint-disable-next-line no-console
        console.warn("Icon is not available in brand \"".concat(brand, "\"."));
        svg = function svg() {
          return null;
        };
    }
  }
  return /*#__PURE__*/React.createElement(SvgIcon, _extends({
    svg: svg
  }, rest));
}